// extracted by mini-css-extract-plugin
export default {"marginTop":"SearchResult_marginTop__mL9II","showOption":"SearchResult_showOption__NtzTY","searchOption":"SearchResult_searchOption__6A7VN"};